module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-GV.7cb57561.png";